// For the new shop settings controller, preview_auto_import_start_date.js does
// something similar.
compiler('[autoimport-setting]', (formgroup) => {
  const csrfToken = document.head.querySelector('meta[name="csrf-token"][content]').content;
  const settingName = formgroup.getAttribute('autoimport-setting');
  const timeFirstSelect = formgroup.querySelector('select[name="automatic_time_first"]');
  const timeSecondSelect = formgroup.querySelector('select[name="automatic_time_second"]');
  const importActiveCheckbox = formgroup.querySelector('input[id^="automatic_import_paused_"]');
  const completeMessage = document.getElementById(`auto_import_start_date_message_${settingName}`)
  const startDateMessage = document.getElementById(`auto_import_start_date_${settingName}`)

  function compareArrays(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  function isActive() {
    if (!importActiveCheckbox.checked) return false;
    if (timeFirstSelect.value !== '') return true;
    return timeSecondSelect.value !== '';
  }

  function activeReports() {
    const reportCheckboxes = Array.from(formgroup.closest('form').querySelectorAll('input[import_source_type=true]:checked'));

    const financeCheckbox = formgroup.querySelector('input[name="finance_api_credit_notes"]')
    if (financeCheckbox != null && financeCheckbox.checked) reportCheckboxes.push(financeCheckbox);

    return reportCheckboxes.map((checkbox) => {
      return checkbox.name.replace("report_type_", "");
    });
  }

  async function queryStartDate(reportTypes) {
    try {
      let response = await fetch("/settings/automatic_import_start_date", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          setting_name: settingName,
          automatic_time_first: timeFirstSelect.value,
          automatic_time_second: timeSecondSelect.value,
          report_types: reportTypes,
        })
      });

      if (response.status !== 200) {
        console.log("Could not query automatic import start date", (await response.text()));
        return;
      }
      response = await response.json()
      return response["start_date"];
    } catch (error) {
      console.error(`Could not query automatic import start date for ${settingName}`, error)
    }
  }

  async function showStartDateMessage(event) {
    if (!isActive()) {
      completeMessage.classList.add("d-none");
      return;
    }

    const chosenReportTypes = activeReports();
    if ((settingName === "amazon_setting" || settingName === "shop_settings_otto_shop_setting") && chosenReportTypes.length === 0) {
      completeMessage.classList.add("d-none");
      return;
    }

    const reportsNotChanged = compareArrays(originalActiveReports, chosenReportTypes);
    if (originallyActivated && reportsNotChanged) {
      completeMessage.classList.add("d-none");
      return;
    }

    const startDate = await queryStartDate(chosenReportTypes);
    if (startDate === null) return;

    startDateMessage.innerHTML = sanitizeHtml(startDate);
    completeMessage.classList.remove("d-none");
  }

  let originallyActivated = isActive();
  let originalActiveReports = activeReports();

  formgroup.querySelectorAll('input,select').forEach((input) => {
    input.addEventListener('change', showStartDateMessage)
  });

  formgroup.closest('form').addEventListener('submit', (event) => {
    // reset initial variables to identify another change after saving
    completeMessage.classList.add('d-none');
    originallyActivated = isActive();
    originalActiveReports = activeReports();
  });
});
